// extracted by mini-css-extract-plugin
export var cuContactReasonDetails = "ContactUs_cuContactReasonDetails__sPDPG";
export var cuContainer = "ContactUs_cuContainer__M1X+P";
export var cuDescriptionDetails = "ContactUs_cuDescriptionDetails__P4JWb";
export var cuForm = "ContactUs_cuForm__kko++";
export var cuInput = "ContactUs_cuInput__BNA9r";
export var cuLabel = "ContactUs_cuLabel__MCa--";
export var cuNameWrapper = "ContactUs_cuNameWrapper__MGzSF";
export var cuSelect = "ContactUs_cuSelect__hUI17";
export var cuSubmitButton = "ContactUs_cuSubmitButton__IAG5p";
export var cuSubtitle = "ContactUs_cuSubtitle__qMLTt";
export var cuTextarea = "ContactUs_cuTextarea__RXMql";
export var cuTitle = "ContactUs_cuTitle__-pxVu";